'use strict';

window.dataLayer = window.dataLayer || [];

var productDataExtractorFactory = function () {
    this.createExtractor = function (type) {
        var productExtractor;

        if (type == 'weightedProduct') {
            productExtractor = new extractWeightedProductData();
            productExtractor.type = type;
        } else if (type == 'default') {
            productExtractor = new extractDefaultProductData();
            productExtractor.type = type;
        } else {
            productExtractor = new extractDefaultProductData();
            productExtractor.type = 'default';
        }

        return productExtractor;
    };
};

var extractWeightedProductData = function () {
    this.extract = function ($product) {
        var sku = $product.data('product-code'),
            name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name'),
            brand = $product.data('product-brand'),
            category = $product.data('product-category-en') ? $product.data('product-category-en') : $product.data('product-category'),
            variantPrice = ($product.data('qty') > 1) ? $product.data('qty') + $product.data('unit-name') : '',
            selectedOption = $product.find('[name=select_element]').find(':selected').text(),
            qty = $product.data('qty') ? getWeightedProductQuantity($product, $product.data('qty'), $product.data('min-qty'), $product.data('unit-increment')) : 1,
            price = getWeightedProductUnitPrice($product, qty);

        if (selectedOption == '') {
            selectedOption = $product.find('.pc--quantity .pc--second-line span').text();
        }
        var productData = {
            name: name != null ? name : '',
            id: sku != null ? sku : '',
            price: price,
            variant: computeVariantField(variantPrice, selectedOption),
            brand: brand != null ? brand : '',
            category: category != null ? category : '',
            quantity: qty
        };

        return productData;
    };

    this.extractGA4 = function ($product) {
        var sku = $product.data('product-code'),
            name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name'),
            brand = $product.data('product-brand'),
            category = $product.data('product-category-en') ? $product.data('product-category-en') : $product.data('product-category'),
            qty = $product.data('qty') ? getWeightedProductQuantity($product, $product.data('qty'), $product.data('min-qty'), $product.data('unit-increment')) : 1,
            price = getWeightedProductUnitPrice($product, qty),
            listName = $product.data('product-list-name') ? $product.data('product-list-name') : $product.closest("[data-list-name]").attr('data-list-name');

        var productData = {
            item_name: name != null ? name : '',
            item_id: sku != null ? sku : '',
            price: price,
            item_brand: brand != null ? brand : '',
            item_category: category != null ? category : '',
            quantity: qty,
            item_list_name: listName != null ? listName : ''
        };
        return productData;
    };
};

function computeVariantField(variantPrice, selectedOption) {
    var variant = '';
    if (variantPrice != null) {
        variant += variantPrice;
    }

    if (selectedOption != '') {
        if (variant != '') {
            variant += ' | ' + selectedOption;
        } else {
            variant += selectedOption;
        }
    }
    return variant;
}

var extractDefaultProductData = function () {
    this.extract = function ($product, quantityAdded) {
        var sku = $product.data('product-code'),
            name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name'),
            brand = $product.data('product-brand'),
            category = $product.data('product-category-en') ? $product.data('product-category-en') : $product.data('product-category'),
            price = $product.find('[data-main-price]').attr('data-main-price'),
            variantPrice = $product.find('[data-variant-price]').attr('data-variant-price'),
            selectedOption = $product.find('[name=select_element]').find(':selected').text(),
            qty = $product.data('qty');

        var productData = {
            name: name != null ? name : '',
            id: sku != null ? sku : '',
            price: price,
            variant: computeVariantField(variantPrice, selectedOption),
            brand: brand != null ? brand : '',
            category: category != null ? category : '',
            quantity: qty

        };

        if (!!quantityAdded) {
            productData.quantity = quantityAdded;
            productData = extractDimensions($product, productData);
        }
        return productData;
    };

    this.extractGA4 = function ($product, quantityAdded) {
        var sku = $product.data('product-code'),
            name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name'),
            brand = $product.data('product-brand'),
            category = $product.data('product-category-en') ? $product.data('product-category-en') : $product.data('product-category'),
            price = $product.find('[data-main-price]').length ? $product.find('[data-main-price]').attr('data-main-price') : $product.attr('data-main-price'),
            qty = $product.data('qty'),
            isInactive = $product.data('is-inactive'),
            listName = $product.data('product-list-name') ? $product.data('product-list-name') : $product.closest("[data-list-name]").attr('data-list-name');

        var productData = {
            item_name: name != null ? name : '',
            item_id: sku != null ? sku : '',
            price: price,
            item_brand: brand != null ? brand : '',
            item_category: category != null ? category : '',
            quantity: qty,
            out_of_stock: isInactive,
            item_list_name: listName
        };

        if (!!quantityAdded) {
            productData.quantity = quantityAdded;
        }
        return productData;
    };
};

var create_product_data = function (productData, listName, position) {
    if (listName != null && position != null) {
        productData.list = listName;
        productData.position = position + 1;
    }

    return productData;
};

var ga4_create_product_data = function ($product, productData, listName) {
    if (listName != null) {
        productData.item_list_name = listName;
    }

    return productData;
};

var ga4_create_product_data_with_listName_undefined = function (productData) {
    // dans le cas de refund item_list_name = undefined
    productData.item_list_name = undefined;
    return productData;
};

var extractDimensions = function ($product, productData) {
    var dimension8 = ($product.find("[data-dimension-8]")).first().attr('data-dimension-8'),
        dimension9 = ($product.find('.select-addToCart .activeOption')).text(),
        dimension10 = $product.data('dimension-10');

    productData.dimension8 = dimension8 != null ? dimension8 : '';
    productData.dimension9 = dimension9 != null ? dimension9 : '';
    productData.dimension10 = dimension10 != null ? dimension10 : '';

    return productData;
};

function isProductInfoPresent(productData) {
    return productData.id != '' || productData.name != '' || productData.price != '' || productData.variant != '';
}

var buildGtmEventLabel = function (labelPrefix, labelMiddle, labelSuffix) {
    return [labelPrefix, labelMiddle, labelSuffix].filter(Boolean).join(' | ');
};

window['push_product_click_metrics'] = function ($product, listName) {
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var gtmProductData = (new productDataExtractorFactory()).createExtractor(productType).extract($product);
    var gtmEventData = {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: {
                    list: listName
                },
                products: [
                    create_product_data(gtmProductData, listName)
                ]
            }
        }
    };

    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product);
    var ga4EventData = {
        event: 'ga4_select_item',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, listName)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

window['push_product_list_metrics'] = function ($optionalTarget) {
    var $products;
    if ($optionalTarget && $optionalTarget.find('.product-tile-spontaneous-purchase').length) {
        //Products from the Spontaneous list
        $products = $optionalTarget.find('.product-tile-spontaneous-purchase');
    } else {
        //Products from the standard list
        $products = $optionalTarget ? $optionalTarget.find('.tile-product') : $('.tile-product');
    }

    var listName = $products.closest('[data-list-name]').data('list-name');
    var impressions = [];

    var i = 0;
    var listNumber = 0;
    impressions[listNumber] = [];
    $products.each(function (idx) {
        var productType = ($(this).data('is-weighted') == true) ? 'weightedProduct' : 'default';
        var productData = (new productDataExtractorFactory()).createExtractor(productType).extract($(this));
        if (isProductInfoPresent(productData)) {
            if (i < 48) {
                impressions[listNumber].push(create_product_data(productData, listName, idx));
                i++;
            } else {
                i = 0;
                listNumber++;
                impressions[listNumber] = [];
            }
        }
    });

    impressions.forEach(function (elements) {
        if (elements.length > 0) {
            pushGtmTrackingEventOnly({
                event: 'productImpressions',
                ecommerce: {
                    impressions: elements
                }
            });
        }
    });
};

window['push_product_detail_metrics'] = function () {
    var $product = $('.productPDP');
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';

    var listName = $product.closest('[data-list-name]').attr('data-list-name');
    if (listName === "productDetail" && sessionStorage.getItem("productsListName")) {
        // get the ga4_view_item's item_list_name
        var productListName = getItemListNameFromSessionStorage("productsListName", $product);
        // check if listName is not undefined and not null
        if (productListName) {
            listName = productListName;
            $product.closest('[data-list-name]').attr('data-list-name', listName);
        }
    }
    var gtmProductData = (new productDataExtractorFactory()).createExtractor(productType).extract($product);
    var gtmEventData = {
        event: 'productDetails',
        ecommerce: {
            detail: {
                products: [
                    create_product_data(gtmProductData, listName)
                ]
            }
        }
    };

    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product);
    var ga4EventData = {
        event: 'ga4_view_item',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, listName)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

window['push_add_cart_info_metrics'] = function ($product, quantityAdded, actionList) {
    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var gtmProductData = (new productDataExtractorFactory()).createExtractor(productType).extract($product, quantityAdded);
    var gtmEventData = {
        event: 'addToCart',
        ecommerce: {
            add: {
                actionField: {
                    list: actionList
                },
                products: [
                    create_product_data(gtmProductData, actionList, null)
                ]
            }
        }
    };

    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product, quantityAdded);
    var ga4EventData = {
        event: 'ga4_add_to_cart',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, actionList)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

window['push_remove_cart_info_metrics'] = function ($product) {
    var sku = $product.data('product-code');
    var name = $product.data('product-name-en') ? $product.data('product-name-en') : $product.data('product-name');

    var gtmEventData = {
        event: 'removeFromCart',
        ecommerce: {
            remove: {
                products: [{
                    name: name != null ? name : '',
                    id: sku != null ? sku : ''
                }]
            }
        }
    };

    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product);
    var listName = $product.data('product-list-name');
    var ga4EventData = {
        event: 'ga4_remove_from_cart',
        ecommerce: {
            items: [
                ga4_create_product_data($product, productData, listName !== null ? listName : '')
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

window['pushPaymentErrorMetrics'] = function () {
    _push_event_to_google('error messages', 'checkout', 'payment method error');
};

window['push_search_result_metrics'] = function (keyword, totalResults, isDidYouMeanTextSearch) {
    var searchCategory = 'global';
    var searchCategoryGA4 = 'global';
    var searchCaseGA4 = 'with results';
    if ($('body').hasClass('theme-online-grocery')) {
        searchCategory = 'products';
        searchCategoryGA4 = 'product';
    }

    if (totalResults == 0) {
        searchCategory += '|sansresultat';
        searchCaseGA4 = 'without results';
    } else if (isDidYouMeanTextSearch && searchCategory !== 'global') {
        searchCategory += '|suggestion';
        searchCategoryGA4 = 'suggestion';
    }

    var gtmEventData = {
        searchCategory: searchCategory,
        searchedKeyword: keyword
    };

    var ga4EventData = {
        event: 'ga4Event',
        eventName: 'search',
        search_term: keyword,
        search_category: searchCategoryGA4,
        search_case: searchCaseGA4,
        search_nb_results: totalResults
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, false);
};

window['pushCheckoutProductsMetrics'] = function (target, step, action, fromCart) {
    var gtmEventData = {
        event: 'checkout',
        ecommerce: {
            checkout: {
                actionField: {
                    step: step,
                    option: ''
                }
            }
        }
    };

    if (fromCart) {
        var ga4EventData = {
            event: 'ga4_begin_checkout',
            ecommerce: {}
        };

        _addProducts(target, gtmEventData, ga4EventData);
        pushGA4TrackingEventOnly(ga4EventData, true);
    }

    if (step == 2) {
        _tryToAddTimeslotSelection(gtmEventData);
    } else if (step == 4) {
        _tryToAddPaymentSelection(gtmEventData);
    }

    var ga4StepName = getCheckoutStepNameGa4Event(step);
    var ga4EventData = {
        event: 'ga4Event',
        eventName: ga4StepName,
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, false);

    if (typeof action === 'function') {
        action();
    }
};

window['pushOrderMetrics'] = function () {
    var $orderGroceryInfo = $('#orderInfoGrocery');
    if ($orderGroceryInfo.length) {
        var gtmProducts = _getProductsForOrderOrCheckout('#cartSummaryOnlineGrocery .product-card--checkout');
        var gtmEventData = {
            orderMethod: $orderGroceryInfo.data('order-service'), // delivery|pick-up
            paymentType: $orderGroceryInfo.data('payment-method'), // Visa|Visa_debit|Amex|Mastercard
            serviceDateTime: $('.orderDate').first().text() + ' ' + $('.orderTime').first().text(),
            firstOrder: $orderGroceryInfo.data('first-order'),
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: $('#dataLayerOrderConfirmationNumGrocery').text(),
                        affiliation: $orderGroceryInfo.data('store-name'),
                        revenue: $orderGroceryInfo.data('total'),
                        tax: $orderGroceryInfo.data('tax'),
                        shipping: $orderGroceryInfo.data('fees'),
                        coupon: $orderGroceryInfo.data('promo-codes-vouchers') // coupons and vouchers id list, split by '|'
                    },
                    products: gtmProducts
                }
            }
        };

        var ga4Products = _getProductsForOrderOrCheckout('#cartSummaryOnlineGrocery .product-card--checkout', true);
        let redeemTotal = 0;
        $("[data-reward-amount]").each(function (index) {
            let redeemAmount = $(this).data('reward-amount');
            if (redeemAmount)
                redeemTotal += redeemAmount;
        })
        var ga4EventData = {
            event: 'ga4_purchase',
            ecommerce: {
                transaction_id: $('#dataLayerOrderConfirmationNumGrocery').text(),
                affiliation: $orderGroceryInfo.data('store-name'),
                currency: 'CAD',
                value: $orderGroceryInfo.data('total'),
                tax: $orderGroceryInfo.data('tax'),
                shipping: $orderGroceryInfo.data('fees'),
                coupon: $orderGroceryInfo.data('ga4-promo-codes'),
                redeem_amount: Number(redeemTotal),
                delivery_method: $orderGroceryInfo.data('order-service'),
                delivery_delay: $orderGroceryInfo.data('order-delay'),
                delivery_timeslot: $('.orderDate').first().data('ga4-timeslot-day') + ' ' + $('.orderTime').first().text(),
                tip_amount: $orderGroceryInfo.data('tip-amount'),
                items: ga4Products
            }
        };

        pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
    }

    _push_event_to_google('checkout', 'cart orders - intent and purchase', '[order placed] grocery cart only');
};

window['pushOrderUpdateMetrics'] = function () {
    _push_event_to_google('ecommerce', 'order update', $('.dataLayerOrderConfirmationNumRefund').text());
    _push_custom_event_to_GA4('order_modification');
};

window['pushReorderProductsMetrics'] = function ($products) {
    if ($products) {
        $products.each(function () {
            var $product = $(this);
            push_add_cart_info_metrics($product, $product.attr('data-qty'), 'reorder'); // One event per product. Asked by metrics team..
        });
    }
};

window['pushRefundOrderMetrics'] = function () {
    var gtmEventData = {
        event: 'transactionRefund',
        ecommerce: {
            refund: {
                actionField: {
                    id: $('.dataLayerOrderConfirmationNumRefund').text()
                }
            }
        }
    };

    var ga4EventData = {
        event: 'ga4_refund',
        ecommerce: {
            transaction_id: $('.dataLayerOrderConfirmationNumRefund').text(),
            refund_case: 'Full'
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

window['pushOrderRefundProductMetrics'] = function (productTile, sku, qty, reason) {
    var gtmEventData = {
        event: 'transactionPartialRefund',
        eventLabel: 'Reason: ' + reason,
        ecommerce: {
            refund: {
                actionField: {
                    id: $('.dataLayerOrderConfirmationNumRefund').text()
                },
                products: [{
                    'id': sku,
                    'quantity': qty
                }]
            }
        }
    };

    var productType = (productTile.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4(productTile);
    var ga4EventData = {
        event: 'ga4_refund_partial',
        ecommerce: {
            transaction_id: $('.dataLayerOrderConfirmationNumRefund').text(),
            refund_case: 'Partial',
            refund_reason: reason,
            items: [
                ga4_create_product_data_with_listName_undefined(productData)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

window['pushAddProductToCartStarterMetrics'] = function ($product, productCode, listName) {
    var gtmEventData = {
        event: 'GAEvent',
        eventCategory: 'ecommerce',
        eventAction: 'add to favorite',
        eventLabel: productCode
    };

    var productType = ($product.data('is-weighted') == true) ? 'weightedProduct' : 'default';
    var ga4ProductData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($product, 1);
    var ga4EventData = {
        event: 'ga4_add_to_wishlist',
        ecommerce: {
            items: [
                ga4_create_product_data($product, ga4ProductData, listName)
            ]
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

function _addProducts(target, data, ga4Data) {
    var products = _getProductsForOrderOrCheckout(target, false);
    var ga4Products = _getProductsForOrderOrCheckout(target, true);
    if (products.length > 0) {
        data.ecommerce.checkout.products = products;
        ga4Data.ecommerce.items = ga4Products;
    }
}

function _getProductsForOrderOrCheckout(target, getProductsForGa4) {
    var $rawProducts = $(target);
    var products = [];
    $rawProducts.each(function () {
        var productType = $(this).data('is-weighted') == true ? 'weightedProduct' : 'default';
        var productData;
        if (getProductsForGa4) {
            productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($(this));
            var listName = $(this).data('product-list-name');
            products.push(ga4_create_product_data($(this), productData, listName !== null ? listName : ''));
        } else {
            productData = (new productDataExtractorFactory()).createExtractor(productType).extract($(this));
            products.push(create_product_data(productData));
        }
    });
    return products;
}

function _getProductsInCart(target) {
    var $rawProducts = $(target);
    var products = [];
    $rawProducts.each(function () {
        var productType = $(this).data('is-weighted') == true ? 'weightedProduct' : 'default';
        var productData = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($(this));
        var listName = $(this).data('product-list-name');
        products.push(ga4_create_product_data($(this), productData, listName !== null ? listName : ''));
    });
    return products;
}

var _push_event_to_google = function (category, action, label) {
    pushGtmTrackingEventOnly({
        event: 'GAEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    });
};

var _push_custom_event_to_GA4 = function () {
    if (arguments.length < 1) {
        console.error('Please specify at least the first parameter for eventName.');
        return;
    } else if (arguments.length % 2 === 0) {
        console.error('The number of arguments must be odd. Arguments should be as followed: eventName, (param1, value1, param2, value2...). Keys/values are optional');
        return;
    }

    let pushContent = {
        event: 'ga4Event',
        'eventName': arguments[0]
    }

    if (arguments.length > 1) {
        for (let i = 1; i < arguments.length; i += 2) {
            pushContent[arguments[i]] = arguments[i + 1];
        }
    }

    pushGA4TrackingEventOnly(pushContent, false);
};

function pushDataLayerSearchStore() {
    var resultStores = $("#nbResultsFound").attr("data-resultNbStore");
    var postalCode = $("#postalCode").val().toLowerCase().trim();
    var city = $(".fs--search-form .city-hidden").val().trim();

    var keyword = postalCode;
    if (postalCode && city) {
        keyword += ' ';
    }
    keyword += city;

    pushGtmTrackingEventOnly({
        searchCategory: (!resultStores || parseInt(resultStores) < 1) ? 'recherche-depicerie|sansresultat' : 'recherche-depicerie',
        searchedKeyword: keyword
    });

    _push_event_to_google('shop', 'search', keyword);
}

function pushDataLayerStoreClick(eventAction) {
    if (eventAction === undefined) {
        return;
    }

    var storeName = $(".store-name").attr("data-storeName");
    var storeStreet = $(".address--street").attr("data-street");
    var storeCity = $(".address--city").attr("data-city");
    var keyword = storeName + ' ' + storeStreet + ' ' + storeCity;

    if (storeName) {
        pushGtmTrackingEventOnly({
            event: 'GAEvent',
            eventCategory: 'recherche-depicerie',
            eventAction: eventAction,
            eventLabel: keyword
        });
    }
}

function pushDataLayerSetFavoriteStore(storeName) {
    _push_event_to_google('shop', 'save as my favourite store', storeName);
}

function pushDataLayerStoreDetailsGetDirections() {
    _push_custom_event_to_GA4('store_directions');
}

function _tryToAddTimeslotSelection(data) {
    var optionPickup = $('#selected-time-slot').data('for-pickup');
    if (optionPickup) {
        data.ecommerce.checkout.actionField.option = 'pickup';
    } else {
        data.ecommerce.checkout.actionField.option = 'delivery';
    }
}

function _tryToAddPaymentSelection(data) {
    var payment = $('.checkout-saved-payment.selected').data('payment-method');
    if (!!payment) {
        data.ecommerce.checkout.actionField.option = payment;
    }
}

function pushDataLayerClipOneCoupon(couponId, loyaltyProgram) {
    var gtmEventData = {
        event: 'GAEvent',
        eventCategory: 'coupon',
        eventAction: loyaltyProgram,
        eventLabel: 'clip-to-card-' + couponId
    };

    var ga4EventData = {
        event: 'ga4Event',
        eventName: 'coupon_clip',
        coupon_id: couponId
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, false);
}

function pushDatalayerCouponClip(cTypeId, cBanner, mobileOnly) {
    _push_custom_event_to_GA4(
        'coupon_clip',
        'coupon_id', cTypeId,
        'coupon_banner_name', cBanner,
        'coupon_exclusif_app', mobileOnly
    );
}

function pushDataLayerClipAllCoupons(couponIds, loyaltyProgram) {
    pushGtmTrackingEventOnly({
        event: 'GAEvent',
        eventCategory: 'coupon',
        eventAction: loyaltyProgram,
        eventLabel: 'clip-to-card-tous-' + couponIds
    });
}

function pushDataLayerPromoCodeAddToCart(promoCode) {
    pushGtmTrackingEventOnly({
        event: 'gaEvent',
        eventCategory: 'checkout',
        eventAction: 'add promo code',
        eventLabel: promoCode
    });
}

function pushDataLayerSubstitutionChanged() {
    pushGtmTrackingEventOnly({
        event: 'gaEventOnce',
        eventCategory: 'checkout',
        eventAction: 'substitutions',
        eventLabel: 'substitute single product toggle'
    });
}

function pushDataLayerSubstitutionHelpMessage() {
    pushGtmTrackingEventOnly({
        event: 'gaEvent',
        eventCategory: 'checkout',
        eventAction: 'substitutions',
        eventLabel: 'help lightbox view'
    });
}

function pushDataLayerSubstitutionUpdatePreferences() {
    pushGtmTrackingEventOnly({
        event: 'gaEvent',
        eventCategory: 'my account',
        eventAction: 'account settings - product substitution',
        eventLabel: 'preference changed'
    });
}

function pushDataLayerNewsletterStickyBtnDisplay() {
    pushGtmTrackingEventOnly({
        event: 'GAEvent',
        eventCategory: 'newsletter lightbox',
        eventAction: 'sticky cta',
        eventLabel: 'click on cta - open lightbox'
    });
}

function pushDataLayerNewsletterStickyBtnClose() {
    pushGtmTrackingEventOnly({
        event: 'GAEvent',
        eventCategory: 'newsletter lightbox',
        eventAction: 'sticky cta',
        eventLabel: 'click on x - hide sticky'
    });
}

function pushDataLayerNewsletterPopupDisplay() {
    pushGtmTrackingEventOnly({
        event: 'GAEvent',
        eventCategory: 'newsletter lightbox',
        eventAction: 'opt-in form',
        eventLabel: 'form view'
    });
}

var CHECKOUT_METRICS = {
    TYPE: {
        SERVICE: 'modify grocery order service',
        TIMESLOT: 'modify grocery order timeslot',
        PAYMENT: 'modify payment method',
        VOUCHER: 'rewards vouchers',
    },

    pushDataLayerChangeCheckout: function (type, origin) {
        var origin = origin ? origin : checkoutStep == 1 ? 'service & timeslot' : checkoutStep == 5 ? 'order review' : null;
        if (origin) {
            pushGtmTrackingEventOnly({
                event: 'gaEvent',
                eventCategory: 'checkout',
                eventAction: origin,
                eventLabel: type
            });
        }
    },

    pushDataLayerCheckoutChangeService: function () {
        CHECKOUT_METRICS.pushDataLayerChangeCheckout(CHECKOUT_METRICS.TYPE.SERVICE);
    },
    pushDataLayerCheckoutChangeTimeslot: function () {
        CHECKOUT_METRICS.pushDataLayerChangeCheckout(CHECKOUT_METRICS.TYPE.TIMESLOT);
    },
    pushDataLayerFastCheckoutChangePayment: function () {
        CHECKOUT_METRICS.pushDataLayerChangeCheckout(CHECKOUT_METRICS.TYPE.PAYMENT);
    },
    pushDataLayerViewRewardsVoucherCheckout: function () {
        CHECKOUT_METRICS.pushDataLayerChangeCheckout('rewards voucher notification viewed', CHECKOUT_METRICS.TYPE.VOUCHER);
    },
    pushDataLayerAddRewardsVoucherCheckout: function () {
        CHECKOUT_METRICS.pushDataLayerChangeCheckout('add rewards voucher in checkout', CHECKOUT_METRICS.TYPE.VOUCHER);
        _push_custom_event_to_GA4('reward_check_use');
    }
};

// CATALOG

function pushDataLayerProductCatalogFilterBy(selectedFiltersCategory, selectedFiltersOption) {
    _push_custom_event_to_GA4(
        'aisles_filter',
        'description', selectedFiltersCategory.trim() + ' | ' + selectedFiltersOption.trim()
    );
}

function pushDataLayerProductDetailZoomIn() {
    _push_event_to_google(
        'ecom catalog - navigation and filters',
        'product details page', 'product image zoom-in'
    );
}

function pushDataLayerCheckoutNavProductCategoryLink() {
    _push_event_to_google('checkout', 'navigation', 'product category link');
}

function pushDataLayerCheckoutNavContinueShoppingGrocery() {
    _push_event_to_google('checkout', 'navigation', 'continue shopping grocery button');
}

function pushDataLayerCheckoutCartIntent(label) {
    _push_event_to_google('checkout', 'cart orders - intent and purchase', label);
}

function pushDataLayerCheckoutCartIntentGroceryOnly() {
    pushDataLayerCheckoutCartIntent('[order intent] grocery cart only');
}

function pushDataLayerCheckoutManageCouponsLink() {
    _push_event_to_google('checkout', 'navigation', 'redirection to coupon page');
}

function pushDataLayerCheckoutPaymentCaptureFailed(label) {
    _push_event_to_google('checkout', 'paysafe pre-auth refused', label);
}

function pushDataLayerCheckoutPaymentCaptureFailedForterDeclined(label) {
    _push_event_to_google('checkout', 'forter has declined', label);
}

function pushDataLayerCheckoutExpressDeliveryNotAvailable() {
    _push_event_to_google('checkout', 'express delivery', 'service not available - lightbox view');
}

function pushDataLayerCheckoutExpressDeliveryNotAvailableChangeService() {
    _push_event_to_google('checkout', 'express delivery', 'service not available - change service');
}

function pushDataLayerAssistancePhoneButton() {
    _push_event_to_google('ecommerce', 'assistance', 'phone button');
}

function pushDataLayerEditOrderFromConfirmation() {
    _push_event_to_google('my account', 'order confirmation - details - change order', 'change my order - grocery');
    _push_custom_event_to_GA4('order_modification_intent');
}

function pushDataLayerFirstOrder() {
    _push_event_to_google('ecommerce', 'first order confirmed');
    _push_custom_event_to_GA4('first_purchase');
}

function pushDataLayerOrderReviewCartReturnToCatalogGrocery() {
    _push_event_to_google('checkout', 'navigation', 'return to grocery catalog button');
}

function pushDataLayerCheckoutFirstStepSeen(step) {
    if (step && !isNaN(step)) {
        var stepNameUA = getCheckoutStepNameUA(step);
        if (stepNameUA !== '') {
            _push_event_to_google('checkout', 'first step seen', stepNameUA);
        }

        var stepNameGA4 = getCheckoutStepNameGA4(step);
        if (stepNameGA4 !== '') {
            _push_custom_event_to_GA4('checkout_first_step_view', 'checkout_landing_step', stepNameGA4);
        }
    }
}

function pushDataLayerOrderHistoryConfirmOrderChange() {
    _push_event_to_google('my account', 'order history - details - change order', 'change my order - grocery');
    _push_custom_event_to_GA4('order_modification_intent');
}

function pushDataLayerCheckoutLogin() {
    _push_event_to_google('checkout', 'user account', 'login link');
}

function pushDataLayerSignUpSignInValidate(eventName, ga4UserEcomSegment, ga4UserFidelitySegment, ga4UserLoyaltyProgram, user_is_banner_buyer, userId, bannerCode) {
    let userIsBannerBuyer = "";
    if (bannerCode === "FOODBASICS") {
        userIsBannerBuyer = "user_is_foodbasics_buyer";
    } else {
        userIsBannerBuyer = "user_is_superc_buyer";
    }

    _push_custom_event_to_GA4(eventName, 'user_id', userId, 'user_segment_ecom', ga4UserEcomSegment, 'user_segment_fidelity', ga4UserFidelitySegment, 'user_fidelity_program', ga4UserLoyaltyProgram, userIsBannerBuyer, user_is_banner_buyer);
}

function pushDataLayerLoginValidate(registeredAccountId, ga4UserEcomSegment, ga4UserLoyaltyProgram) {
    _push_event_to_google('sign in form clicks', 'top menu pop up form', 'login validate');
    _push_custom_event_to_GA4('login', 'user_id_custom', registeredAccountId, 'user_segment_ecom', ga4UserEcomSegment, 'user_fidelity_program', ga4UserLoyaltyProgram);
}

function pushDataLayerSignIn() {
    _push_event_to_google('sign in form clicks', 'top menu pop up form', 'sign in intent');
}

function pushDataLayerCheckoutSignIn() {
    _push_event_to_google('sign in form clicks', 'top menu pop up form', 'sign in intent - from checkout process');
}

function pushDataLayerAccountCreation(gaLoyaltyProgram, ga4RegisteredAccountId, ga4LoyaltyProgram,
                                      card,
                                      subjectId,
                                      ga4UserFidelitySegment,
                                      user_is_metro_buyer) {
    _push_event_to_google('account creation', gaLoyaltyProgram);
    _push_custom_event_to_GA4('sign_up',
        'user_id', subjectId,
        'user_segment_fidelity', ga4UserFidelitySegment,
        'user_segment_ecom', 'connected without purchase',
        'user_fidelity_program', ga4LoyaltyProgram,
        'user_is_metro_buyer', user_is_metro_buyer);
}

function pushDataLayerLinkingCardErrorMyAccount(errorMsg) {
    _push_custom_event_to_GA4('error_message', 'error_description', 'card linking | ' + errorMsg);
}

function pushDataLayerCheckoutSmsNewlyActivated(fromStep) {
    _push_event_to_google('checkout', 'status notification opt-in', fromStep);
}

//Big Menu and Big menu hamburger
function pushDataLayerBigMenuSubsite(menuName, label) {
    _push_event_to_google(menuName, 'navigation', label);
}

function pushDataLayerBigMenuLevel(menuName, levelName) {
    _push_event_to_google(menuName, 'navigation', levelName);
}

function pushDataLayerBigMenuSubsiteTrending(menuName, label) {
    _push_event_to_google(menuName, 'trending now', label);
}

function pushDataLayerBigMenuThemeZone(menuName, label) {
    _push_event_to_google(menuName, 'navigation', 'thematic zone | ' + label);
}

function pushDataLayerBigMenuTopButton(menuButtonLabel) {
    _push_event_to_google('big menu', 'navigation', menuButtonLabel);
}

function pushDataLayerHeaderActionLink(action, label) {
    _push_event_to_google('black header clicks', action, label);
}

function pushDataLayerTopFooterActionLink(label) {
    _push_event_to_google('footer', 'top nav clicks', label);
}

function pushDataLayerBottomFooterActionLink(label) {
    _push_event_to_google('footer', 'bottom nav clicks', label);
}

function pushDataLayerChooseNewService(eventCategory, action, label) {
    _push_event_to_google(eventCategory, action, label);
}

// Service and timeslot
const gaPushOnPanelView = function (originOfPanel, serviceType, timeslotType, availability) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_view',
        'type', serviceType + ' - ' + timeslotType + ' timeslots',
        'origin', originOfPanel,
        'availability', availability
    );
}

const gaPushOnPanelServiceClick = function (elmText, serviceType, partnerType, timeslotType) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_click',
        'type', serviceType + ' - ' + timeslotType + ' timeslots',
        'partner', partnerType,
        'link_text', elmText
    );
}

const gaPushOnPanelClose = function (serviceType, timeslotType, availability) {
    _push_custom_event_to_GA4(
        'service_ts_side_panel_close',
        'type', serviceType + ' - ' + timeslotType + ' timeslots',
        'availability', availability
    );
}
const gaPushOnOverlayView = function () {
    _push_custom_event_to_GA4(
        'service_ts_overlay_view'
    );
}
const gaPushOnOverlayClose = function () {
    _push_custom_event_to_GA4(
        'service_ts_overlay_close'
    );
}
const gaPushOnOverlayClick = function (linkText) {
    _push_custom_event_to_GA4(
        'service_ts_overlay_click',
        'link_text', linkText
    );
}

function pushDataLayerServiceAndTimeslot(action, label) {
    pushGtmTrackingEventOnly({
        event: 'gaEvent',
        eventCategory: 'service and timeslot',
        eventAction: action,
        eventLabel: label
    });
}

function pushDataLayerServiceAndTimeslotDelivery(storeName, mpriority) {
    if (mpriority) {
        pushDataLayerServiceAndTimeslot('select a service', 'delivery ' + storeName + ' | mpriority');
    } else {
        pushDataLayerServiceAndTimeslot('select a service', 'delivery ' + storeName);
    }
}

function pushDataLayerServiceAndTimeslotExpressDelivery(storeName) {
    pushDataLayerServiceAndTimeslot('select a service', 'express delivery ' + storeName);
}

function pushDataLayerServiceAndTimeslotEDBannerShown() {
    pushDataLayerServiceAndTimeslot('express delivery', 'max items - sticky view');
}

function pushDataLayerServiceAndTimeslotPickup(storeName, mpriority) {
    if (mpriority) {
        pushDataLayerServiceAndTimeslot('select a service', 'pick up ' + storeName + ' | mpriority');
    } else {
        pushDataLayerServiceAndTimeslot('select a service', 'pick up ' + storeName);
    }
}

function pushDataLayerServiceAndTimeslotTimeslot(timeslot) {
    pushDataLayerServiceAndTimeslot('select timeslot', timeslot);
}

function pushDataLayerServiceAndTimeslotTimeslotClose() {
    pushDataLayerServiceAndTimeslot('skip for now', 'click on the x');
}

function pushDataLayerServiceAndTimeslotCriteriasForm() {
    pushDataLayerServiceAndTimeslot('mpriority form', 'validate form');
}

function pushDataLayerOtherFlavoursClick() {
    _push_event_to_google('ecom catalog - navigation and filters', 'view other variants', 'show flavours product carousel');
}

function pushDataLayerOrderPackagingOption(packingOption) {
    _push_event_to_google('checkout', 'order packaging option', packingOption);
}

function pushDataLayerMyAccountEditAccountAddressSuccess() {
    _push_event_to_google('my account', 'address', 'address modified - reward cheques');
    _push_custom_event_to_GA4('reward_check_address_modify');
}

function pushDataLayerMyAccountEditEcommAddressSuccess() {
    _push_event_to_google('my account', 'address', 'address modified - delivery');
}

// Cookie consent
function pushDataLayerCookieConsentAccept() {
    _push_event_to_google('user consent', 'sticky bottom banner', 'button - acknowledgement');
}

function pushDataLayerCookieConsentConditions() {
    _push_event_to_google('user consent', 'sticky bottom banner', 'link - redirection to privacy protection policy page');
}

// Mini-cart
function pushDataLayerBlackHeaderClickShoppingCartMinicart() {
    _push_event_to_google('black header clicks', 'my shopping cart', 'minicart');
}

function pushDataLayerBlackHeaderClickShoppingCartRedirectCartPage() {
    _push_event_to_google('black header clicks', 'my shopping cart', 'redirection to shopping cart page');
}

function pushDataLayerMinicartPopUpClose() {
    _push_event_to_google('checkout', 'navigation', 'minicart | close by clicking on x');
}

function pushDataLayerMinicartPopUpCloseClickAway() {
    _push_event_to_google('checkout', 'navigation', 'minicart | close by clicking away');
}

function pushDataLayerMinicartContinueShopping() {
    _push_event_to_google('checkout', 'navigation', 'minicart | continue shopping grocery button');
}

function pushDataLayerMinicartPopUpContinueShopping() {
    _push_event_to_google('checkout', 'navigation', 'minicart | see grocery promo button');
}

function pushDataLayerMinicartPopUpRedirectToShoppingCart() {
    _push_event_to_google('checkout', 'cart orders - intent and purchase', '[order intent] grocery minicart only');
}

function pushDataLayerAccountDeleteIntent() {
    _push_custom_event_to_GA4(
        'delete_account_intent',
        'description', 'super c account deletion'
    );
}

function pushDataLayerCardCreateIntent() {
    _push_custom_event_to_GA4('card_create_intent');
}

function pushDataLayerNewsletterSubscriptionFromCardLink(origin) {
    _push_custom_event_to_GA4(
        'newsletter_subscribe',
        'newsletter_name', 'moi',
        'origin', origin
    );
}

function pushDataLayerNewsletterSubscription(newsletterName, origin) {
    _push_custom_event_to_GA4(
        'newsletter_subscribe',
        'newsletter_name', newsletterName,
        'origin', origin
    );
}

function pushDatalayerDeactivateCard(lostOrStolen) {
    _push_custom_event_to_GA4(
        'card_disable',
        'description', lostOrStolen ? 'card lost or stolen' : 'other'
    );
}

function pushLinkCardStepMetrics(step) {
    if (step && !isNaN(step)) {
        _push_custom_event_to_GA4('card_link_intent', 'step', step + '/3');
    }
}

function pushDataLayerOrderModificationIntent() {
    _push_custom_event_to_GA4(
        'order_modification_intent'
    );
}

function pushDataLayerReceiptSubscription() {
    _push_custom_event_to_GA4(
        'e_receipt_subscribe'
    );
}

function pushEventDeleteAccountSuperC() {
    _push_custom_event_to_GA4(
        'delete_account_confirmation',
        'description', 'super c account deletion'
    );
}

function pushEventCouponImpression(couponTypeId, couponBanner, couponExclusiveApp) {
    _push_custom_event_to_GA4(
        'coupon_view',
        'coupon_id', couponTypeId,
        'coupon_banner_name', couponBanner,
        'coupon_exclusif_app', couponExclusiveApp
    );
}

function ga4ViewCart() {
    var $productContainer = $('.mini--cart--product').length ? $('.mini--cart--product') : $('.product-card');
    var products = _getProductsInCart($productContainer);
    var ga4EventData = {
        event: 'ga4_view_cart',
        ecommerce: {
            items: products
        }
    };
    pushGA4TrackingEventOnly(ga4EventData, true);
}

window['push_remove_all_from_cart_info_metrics'] = function ($products) {
    var productsToSend = [];
    var ga4ProductsToSend = [];
    $products.each(function () {
        var product = {
            name: $(this).data('product-name-en') ? $(this).data('product-name-en') : $(this).data('product-name'),
            id: $(this).data('product-code')
        };
        productsToSend.push(product);
        var productType = $(this).data('is-weighted') == true ? 'weightedProduct' : 'default';
        var ga4Product = (new productDataExtractorFactory()).createExtractor(productType).extractGA4($(this));
        var listName = $(this).data('product-list-name');
        ga4ProductsToSend.push(ga4_create_product_data($(this), ga4Product, listName !== null ? listName : ''));
    });

    var gtmEventData = {
        event: 'removeFromCart',
        ecommerce: {
            remove: {
                products: productsToSend
            }
        }
    };

    var ga4EventData = {
        event: 'ga4_remove_from_cart',
        ecommerce: {
            items: ga4ProductsToSend
        }
    };

    pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, true);
};

function getCheckoutStepNameUA(step) {
    var stepName = '';
    if (step === 1) {
        stepName = 'service and time selection';
    } else if (step === 2) {
        stepName = 'account information';
    } else if (step === 3) {
        stepName = 'payment method';
    } else if (step === 5) {
        stepName = 'order validation';
    }
    return stepName;
}

function getCheckoutStepNameGA4(step) {
    var ga4StepLabel = '';
    if (step === 1) {
        ga4StepLabel = 'step-1_services';
    } else if (step === 2) {
        ga4StepLabel = 'step-2_account';
    } else if (step === 3) {
        ga4StepLabel = 'step-3_payment';
    } else if (step === 5) {
        ga4StepLabel = 'step-4_order-review';
    }
    return ga4StepLabel;
}


// -------------------------------------------------------------------------
// Tracking in mobile app should be consistent with GA4 tracking on website
// -------------------------------------------------------------------------

function sendTrackingEventToDevice(eventData) {
    sendWebviewEventToDevice("trackEvent", {eventData: eventData});
}

function pushTrackingEventToAppropriateContainer(gtmEventData, ga4EventData, pushEmptyEcommerceBeforeGA4) {
    if (typeof inWebview !== 'undefined' && inWebview) {
        if (ga4EventData) {
            sendTrackingEventToDevice(ga4EventData);
        }
    } else {
        if (gtmEventData) {
            dataLayer.push(gtmEventData);
        }

        if (ga4EventData) {
            dataLayer = window.dataLayer || [];

            if (typeof pushEmptyEcommerceBeforeGA4 !== 'undefined' && pushEmptyEcommerceBeforeGA4) {
                dataLayer.push({ecommerce: null});
            }
            dataLayer.push(ga4EventData);
        }
    }
}

function pushGtmTrackingEventOnly(gtmEventData) {
    pushTrackingEventToAppropriateContainer(gtmEventData, null, false);
}

function pushGA4TrackingEventOnly(ga4EventData, pushEmptyEcommerceBeforeGA4) {
    pushTrackingEventToAppropriateContainer(null, ga4EventData, pushEmptyEcommerceBeforeGA4);
}

function pushHotJarEvent(event) {
    if (typeof hj === 'function') { // might be blocked by ad-blocker extensions
        hj('trigger', event);
    }
}

function getItemListNameFromSessionStorage(storageProductList, $product) {
    var storageProductsListName = JSON.parse(sessionStorage.getItem(storageProductList));
    if (storageProductsListName) {
        var sku = $product.data('product-code');
        var lastItem = storageProductsListName.slice().reverse().find(item => item.productId === sku);
        if (lastItem)
            return lastItem.productListName;
    }
}

function getWeightedProductQuantity($product, qty, minQty, increment) {
    // transform the weight of products to integer quantity
    if ($product && $product.data('ordered-qty') != null) {
        qty = $product.data('ordered-qty');
    }
    return qty / increment;
}

function getWeightedProductUnitPrice($product, qty) {
    var totalePrice = $product.hasClass('mini--cart--product') ? $product.data("subtotal-price") : $product.find("[data-subTotal-price]").attr('data-subTotal-price');
    if (!totalePrice) {
        // GA4_add_to_ cart Prendre en considération les prix pour les produits de type 'weighted', où le prix dépend d'une liste déroulante (prix/poids) dans le format suivant: x $ env. ch.
        return $product.find('.price-update').text().replace(/\s*\$\s*/, "").replace(",", ".");
    } else {
        // traiter tous les types de produits, meme ceux avec selectedConfiguration
        return (totalePrice / qty).toFixed(2);
    }
}

function getCheckoutStepNameGa4Event(step) {
    let ga4Step = step - 1; // In GA4, step 1 = services (while step 1 in UA is cart)
    if (ga4Step === 4) {
        ga4Step = "_sms";
    }

    return 'checkout_step' + ga4Step + '_view';
}